export const hireMachineLearning = {

    // HirePageBanner Content
    mainBanner: {
        shortHeading: "Business-Focused AI Engineers Driving Innovation",
        mainHeading: "Expert <span>Machine Learning</span> engineers trusted by 50+ global companies.",
        content: "Our engineers specialize in building predictive models, automating workflows, and leveraging raw data to create intelligent solutions that fuel business growth. Partner with us to accelerate your innovation and deploy solutions that create measurable business impact.",
    },

    // HirePageExperties Content
    flutterExpertise: {
        btnText: "Hire Flutter Developers For Any Service",
        shortHeading: "Our Machine Learning Engineering Services",
        heading: "Building Scalable, High-Performance Machine Learning Solutions That Drive Business Growth",
        description: "We specialize in delivering cutting-edge Machine Learning solutions tailored to your business goals. Our expert engineers build high-performing, scalable models and systems that turn data into actionable insights, drive innovation, and enhance decision-making. As trusted partners in Machine Learning development, we provide dedicated engineers who create intuitive, reliable, and future-ready ML solutions to help your business excel in an increasingly data-driven world.",
        servicesData: [
            {
                title: "Artificial Intelligence (AI)",
                description:
                    "We create AI-driven solutions that help businesses automate processes, personalize experiences, and unlock innovative pathways to value creation.",
                icon: "/images/hire-page-icons/flutter-icon-1.svg",
            },
            {
                title: "Neural Network Development",
                description:
                    "Our engineers design and build advanced neural networks using architectures like CNNs, RNNs, and transformers to solve complex problems like fraud detection, medical diagnostics, and more.",
                icon: "/images/hire-page-icons/flutter-icon-2.svg",
            },
            {
                title: "Deep Learning",
                description:
                    "We develop deep learning models for image, text, voice, and video analysis, helping businesses extract meaningful insights from unstructured data and drive better decision-making.",
                icon: "/images/hire-page-icons/flutter-icon-3.svg",
            },
            {
                title: "Big Data & Predictive Analytics",
                description:
                    "We leverage big data to generate predictive insights that give you a competitive edge. Our models help you anticipate trends and make data-backed decisions in real-time.",
                icon: "/images/hire-page-icons/flutter-icon-4.svg",
            },
            {
                title: "Computer Vision",
                description:
                    "Build intelligent systems that can analyze and interpret visual data. Our computer vision models help automate image classification, object detection, and even facial recognition.",
                icon: "/images/hire-page-icons/flutter-icon-5.svg",
            },
            {
                title: "Speech Recognition",
                description:
                    "We design systems that accurately convert speech into text, even in noisy environments or with specialized terminology perfect for improving accessibility and customer service.",
                icon: "/images/hire-page-icons/flutter-icon-6.svg",
            },
            {
                title: "Sentiment Analysis",
                description:
                    "Gain deeper insights into customer feedback and emotions. Our sentiment analysis models help you understand what people really feel, enabling you to adjust products, services, and marketing strategies effectively.",
                icon: "/images/hire-page-icons/flutter-icon-7.svg",
            },
            {
                title: "Natural Language Processing (NLP)",
                description:
                    "When systems need to understand human language, we build NLP models that read, interpret, and generate text, enabling automation and smarter customer interactions.",
                icon: "/images/hire-page-icons/flutter-icon-8.svg",
            },
            {
                title: "Robotic Process Automation (RPA)",
                description:
                    "Automate repetitive tasks with RPA and free up your team to focus on high-value activities. Our RPA solutions streamline workflows and reduce operational costs.",
                icon: "/images/hire-page-icons/flutter-icon-1.svg",
            },
        ]
    },

    ctaSection: {
        mainHeading: "Struggling to make sense of complex data?",
        description: "Let our machine learning engineers transform your raw data into intelligent, actionable insights.",
        btnText: "Get in Touch with Our Experts Today",
        btnLink: "/contact-us",
    },

    testimonialsData: [
        {
            name: "Michael Fisker",
            enterprise: "Enterprise Automation",
            country: "Austin, US",
            profileImage: "/images/testimonials/michael.avif",
            logoImage: "/images/logo-2.png",
            countryFlagImage: "/images/testimonials/flags/usa-flag.png",
            designation: "CTO at BrightPath Logistics",
            feedback:
                "The Machine Learning engineer worked with us to develop a predictive model that greatly improved our logistics forecasting. We now make data-driven decisions with significantly higher accuracy, reducing operational costs and boosting client satisfaction.",
            serviceTags: ["Enterprise Automation"]
        },
        {
            name: "Emily Roberts",
            enterprise: "Healthcare AI",
            country: "San Francisco, US",
            countryFlagImage: "/images/testimonials/flags/usa-flag.png",
            designation: "Head of Data Science at HealthPlus",
            profileImage: "/images/testimonials/sophie.avif",
            logoImage: "/images/logo-2.png",
            feedback: "The ML engineer implemented a deep learning model that helped us analyze patient data in real-time, detecting health patterns with much higher accuracy. Their expertise truly enhanced our services and helped improve patient outcomes.",
            serviceTags: ["Healthcare SolutionsI"]
        },
    ],

    // DevelopmentPerformance Content (Why Choose Us)
    whyUsContent: {
        // shortHeading: "150+ Successful Projects in Web & AI Development",
        heading: " with Our Machine Learning Engineers?",
        greenHeading: "Why Work",
        content: "We provide expert Machine Learning engineers who specialize in creating reliable, scalable, and automated ML solutions that empower your business. Our team combines advanced technical expertise, agility, and precision to help you accelerate delivery, optimize operations, and drive real business growth.",
        stats: [
            {
                title: "Support Faster Deployment",
                number: "24/7", // continuous support availability
            },
            {
                title: "Scalable Systems",
                number: "99.9%", // typically represents uptime or scalability reliability
            },
            {
                title: "Continuous Improvement",
                number: "10x", // indicates significant improvement speed or efficiency
            },
            {
                title: "Business-Aligned Solutions",
                number: "100%", // expresses complete alignment with business goals
            },
        ],
        cta: {
            text: "Partner With us Today",
            link: "/contact-us",
        }
    },

    mlSolutionsData: [
        {
            title: "Access to Pre-Vetted ML Talent",
            description:
                "We provide access to a network of 500+ rigorously tested Machine Learning engineers, data scientists, and MLOps specialists. Each professional is screened for coding ability, domain expertise, and production experience, ensuring that you onboard top-tier talent, not trainees.",
        },
        {
            title: "Rapid Onboarding & Seamless Integration",
            description:
                "Our engineers integrate with your team in as little as 48 hours. We align time zones, reporting methods, and delivery cycles, ensuring smooth collaboration and eliminating delays from day one.",
        },
        {
            title: "End-to-End MLOps Implementation",
            description:
                "We streamline your ML workflows by implementing CI/CD pipelines for model training, deployment, and monitoring. This reduces manual workloads by up to 30% and accelerates model iteration cycles by 50%, guaranteeing faster deployment and stable production performance.",
        },
        {
            title: "Scalable Infrastructure & Cloud Optimization",
            description:
                "We optimize your ML infrastructure to handle large-scale workloads, saving up to 40% in cloud costs by configuring cost-efficient environments on platforms like AWS, Azure, and GCP. Our engineers automate scaling to ensure resources are balanced against business needs without any overruns.",
        },
        {
            title: "Robust Security & Compliance",
            description:
                "We ensure 100% compliance with ISO, SOC 2, and GDPR standards. All projects begin under a strict NDA, and we maintain audit-ready documentation throughout the ML lifecycle, ensuring the highest level of data protection.",
        },
        {
            title: "Continuous Delivery & Measurable Results",
            description:
                "We monitor deployed models in real-time and conduct performance retraining when necessary, improving model efficiency by up to 20%. Our proactive maintenance ensures that your ML systems remain relevant and consistently deliver measurable ROI.",
        },
    ],

    // HireCombinationSection Content
    techCombinations: {
        shortHeading: "Powerful Technology Combinations Our Machine Learning Engineers Use",
        heading: "Top Machine Learning Frameworks for Scalable, Intelligent Development",
        description: "We combine industry-leading Machine Learning frameworks and data technologies to build secure, reliable, and high-performing AI solutions. Each technology pairing is chosen to enhance scalability, efficiency, and model precision, delivering measurable business value and real-world impact.",
        combinations: [
            {
                title: "Python + TensorFlow",
                description:
                    "TensorFlow offers a complete ecosystem for deep learning, from prototyping to production. Combined with Python’s versatility, this pairing enables efficient model training, GPU acceleration, and deployment across cloud and edge environments.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "tensorflow.svg", altText: "TensorFlow deep learning framework" },
                ],
            },
            {
                title: "Python + PyTorch",
                description:
                    "PyTorch’s dynamic computation graph and developer-friendly design make it ideal for experimentation and innovation. In tandem with Python, it empowers faster iteration, transparent debugging, and research-to-production scalability.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "pytorch.svg", altText: "PyTorch deep learning library" },
                ],
            },
            {
                title: "Python + Scikit-learn",
                description:
                    "Scikit-learn streamlines classical ML tasks like regression, classification, and clustering. Its seamless integration with Python makes it perfect for quick development, feature testing, and enterprise-grade deployment.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "scikit-learn.svg", altText: "Scikit-learn ML library" },
                ],
            },
            {
                title: "Python + Keras",
                description:
                    "Keras simplifies deep learning through an intuitive API for building, training, and fine-tuning neural networks. Paired with Python, it enables rapid experimentation and seamless integration with TensorFlow backends.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "keras.svg", altText: "Keras neural network library" },
                ],
            },
            {
                title: "Python + Apache Spark",
                description:
                    "Apache Spark handles distributed data processing at scale. Together with Python (via PySpark), it enables high-speed analytics, large-scale training pipelines, and real-time predictive systems for data-driven enterprises.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "apache.svg", altText: "Apache Spark data processing framework" },
                ],
            },
            {
                title: "Python + AWS SageMaker",
                description:
                    "AWS SageMaker offers a powerful platform for model training, optimization, and deployment in the cloud. Using Python SDKs, our ML experts automate pipelines and scale AI workloads efficiently.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "aws.svg", altText: "AWS SageMaker cloud ML platform" },
                ],
            },
            {
                title: "Python + XGBoost",
                description:
                    "XGBoost is a leading framework for gradient boosting, known for exceptional speed and accuracy. Integrated with Python, it’s ideal for structured data, predictive modeling, and financial risk assessment.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "xgboost.png", altText: "XGBoost machine learning library" },
                ],
            },
            {
                title: "Python + LightGBM",
                description:
                    "LightGBM excels in handling large datasets and achieving high-performance model training. When used with Python, it boosts efficiency for ranking, classification, and regression problems across industries.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "light-gbm.png", altText: "LightGBM gradient boosting framework" },
                ],
            },
            {
                title: "Python + OpenCV",
                description:
                    "OpenCV brings advanced computer vision capabilities to Python, enabling ML engineers to build intelligent systems for image recognition, video analytics, and object detection with precision and speed.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "open-cv.svg", altText: "OpenCV computer vision library" },
                ],
            },
            {
                title: "Python + spaCy",
                description:
                    "spaCy powers Natural Language Processing (NLP) with fast, production-ready pipelines. When combined with Python, it helps businesses analyze sentiment, automate text classification, and extract insights from unstructured data.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "spacy.png", altText: "spaCy NLP framework" },
                ],
            },
            {
                title: "Python + Hugging Face Transformers",
                description:
                    "Hugging Face’s Transformer library, combined with Python, delivers cutting-edge NLP and generative AI capabilities from chatbots and summarization tools to large language model (LLM) fine-tuning and deployment.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "huggin-face.png", altText: "Hugging Face Transformers library" },
                ],
            },
            {
                title: "Python + Google Vertex AI",
                description:
                    "Vertex AI simplifies building, deploying, and managing ML models at scale. Our engineers use Python APIs to leverage Google’s cloud infrastructure, accelerating MLOps automation and end-to-end lifecycle management.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "vertex-ai.png", altText: "Google Vertex AI platform" },
                ],
            },
            {
                title: "Python + MLflow",
                description:
                    "MLflow enables experiment tracking, model versioning, and lifecycle management. Paired with Python, it ensures reproducible results and smooth transitions from development to production.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "mlflow.png", altText: "MLflow MLOps framework" },
                ],
            },
            {
                title: "Python + LangChain",
                description:
                    "LangChain is a powerful framework for developing applications using Large Language Models (LLMs). Paired with Python, it provides seamless integrations for tasks like document summarization, conversation bots, and data extraction, enabling automated workflows and intelligent system building.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "langchain.png", altText: "LangChain LLM framework" },
                ],
            },
            {
                title: "Python + LangFuse",
                description:
                    "LangFuse combines the power of LLMs with real-time data streams, providing AI-driven insights for live applications. With Python, it enables context-aware interactions, data enrichment, and real-time decision-making capabilities that drive innovation in industries like finance, healthcare, and e-commerce.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "langfuse.png", altText: "LangFuse AI monitoring tool" },
                ],
            },
        ]
    },

    whyChooseBitsclanContet: [
        {
            id: "Tab1",
            label: "Vetted Senior ML Talent",
            content:
                "Only the top 1% of applicants qualify after rigorous evaluations in data science, deep learning, and algorithm design. Each engineer brings proven experience in developing scalable, production-grade AI and machine learning solutions.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "Timezone-Aligned Collaboration",
            content:
                "Teams operate within your working hours, joining standups, sync calls, and sprint reviews in real time. This enables faster feedback loops, immediate responses, and continuous model optimization without project delays.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "Proficient in Communication",
            content:
                "Engineers are fluent communicators who can clearly explain complex ML concepts to both technical and non-technical stakeholders. This ensures smooth collaboration between engineering, business, and data science teams.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab4",
            label: "Full-Stack AI & Data Capabilities",
            content:
                "From data engineering and model training to MLOps deployment, the team handles every layer of the AI pipeline. Expertise spans ETL pipelines, model evaluation, real-time analytics, and enterprise-grade integration.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab5",
            label: "Scalable Teams",
            content:
                "Whether scaling an internal team or launching a new ML project, additional talent can be onboarded in days. Flexible engagement models ensure agility, continuity, and rapid scaling without compromising quality.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab6",
            label: "Standard MSAs & SOWs",
            content:
                "Onboarding is streamlined through legally compliant agreements, including standardized MSAs and SOWs. This ensures alignment with enterprise procurement standards for transparency and ease of engagement.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab7",
            label: "NDA & IP Protection",
            content:
                "Data confidentiality and intellectual property protection are built into every engagement. Strict NDAs and security protocols safeguard proprietary models, algorithms, and datasets throughout the project lifecycle.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab8",
            label: "Enterprise-Grade Security",
            content:
                "All ML development adheres to leading global compliance frameworks such as ISO, SOC 2, and GDPR. Strict access control, encrypted repositories, and audit-ready workflows ensure maximum data protection.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab9",
            label: "Managed Delivery",
            content:
                "Project delivery is continuously monitored by experienced leads who track progress, address blockers, and ensure quality benchmarks are met. Every milestone is achieved with measurable precision and on-time delivery.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
    ],

    engagementModels: {
        shortHeading: "Engagement Models",
        heading: "Flexible Engagement Models for Seamless ML Integration",
        subheading: "Need Machine Learning expertise? Plug us in where you need us most. We adapt to your workflow, priorities, and goals whether you’re scaling your data team, launching an AI initiative, or outsourcing end-to-end ML development.",
        models: [
            {
                icon: "/images/engagement-model-gifs/hourly-icon.svg",
                index: 1,
                iconWidth: 40,
                title: "Scale with Flexible Teams",
                description: "Need additional Machine Learning engineers or data scientists on your existing team? Instantly scale in-house capabilities with pre-vetted experts skilled in model development, optimization, and deployment no lengthy hiring cycles."
            },
            {
                icon: "/images/engagement-model-gifs/price-icon.svg",
                index: 2,
                iconWidth: 35,
                title: "Dedicated Teams for Long-Term ML Success",
                description: "Need a complete team to handle multiple AI or data-driven projects? We assemble full-time ML teams dedicated solely to your business goals, covering everything from data engineering and model training to performance monitoring."
            },
        ],
        cta: {
            text: "Talent on Your Terms",
            button: "Accelerate with Machine Learning",
            link: "/contact-us",
        },
    },

    // HirePageSteps Content
    hireSteps: {
        btnText: "Let’s Find Your Perfect Developer",
        heading: "How to Engage Machine Learning Engineers in 3 Simple Steps",
        // subHeading: "Hiring expert Flutter developers is simple with our 4-step process. We focus on making sure you get the right developer for your project—fast, reliable, & cost-effective.",
        steps: [
            {
                title: "Connect with Our Expert Consultants",
                description:
                    "Speak with one of our machine learning advisors at Bitsclan to discuss your project’s goals, technical needs, and team dynamics. We ensure a clear understanding of your business requirements and match you with the right talent.",
                icon: "/images/hire-page-setps-icons/icon-1.svg",
            },
            {
                title: "Work with Hand-Picked Talent",
                description:
                    "Within 24–48 hours, we’ll introduce you to a hand-selected Machine Learning Engineer who aligns with your project needs. Our experts are ready to make an impact right away, ensuring your project moves forward seamlessly.",
                icon: "/images/hire-page-setps-icons/icon-2.svg",
            },
            {
                title: "The Right Fit, Guaranteed",
                description:
                    "We offer a trial period to confirm the engineer is the right fit for your team and project. If you’re not completely satisfied, we’ll provide another candidate, at no additional cost, ensuring the perfect match for your needs.",
                icon: "/images/hire-page-setps-icons/icon-3.svg",
            },
        ],
    },

    // CoverTheStack Content
    coverTheStack: {
        whereStart: "Backend",
        mainHeading: "Comprehensive Expertise Across the ML Stack",
        subHeading: "Our machine learning engineers leverage a modern tech stack designed for performance, scalability, and real-world impact. With hands-on experience across 100+ tools and frameworks, we deliver end-to-end ML solutions from data engineering and model development to deployment, monitoring, and optimization.",
        tabs: [
            "Backend",
            "Database",
            "Cloud Services",
        ],
        tabItems: [
            { tab: "Backend", icon: "/images/tech-stack-icons/dart.svg", name: "Dart" },
            { tab: "Backend", name: "Firebase", icon: "/images/tech-stack-icons/firebase.png", },
            { tab: "Backend", name: "Node.js", icon: "/images/database9.png", },
            { tab: "Database", icon: "/images/db1.png", name: "Firebase" },
            { tab: "Database", icon: "/images/db7.png", name: "SQLite" },
            { tab: "Cloud Services", icon: "/images/cloud3.png", name: "AWS" },
            { tab: "Cloud Services", name: "Google Cloud", icon: "/images/cloud1.png", },
        ],
    },



    challengesData: [
        {
            title: "Finding Skilled ML Talent",
            description:
                "The demand for experienced machine learning engineers far exceeds supply. Most candidates have academic knowledge but lack hands-on experience in building, deploying, and maintaining real-world ML systems.",
        },
        {
            title: "Lengthy Hiring & Evaluation Process",
            description:
                "Screening ML candidates is complex and time-consuming. Evaluating data science expertise, coding ability, and model optimization skills often takes months—slowing project timelines and innovation cycles.",
        },
        {
            title: "Cost Overruns & Inefficient Infrastructure",
            description:
                "Inefficient training cycles, unoptimized compute resources, and lack of automation often lead to spiraling cloud costs—especially when models are retrained frequently or handle large-scale data.",
        },
        {
            title: "Communication Gaps Between Teams",
            description:
                "Bridging the gap between technical ML engineers and non-technical stakeholders can be difficult. Misalignment in objectives or metrics often leads to delays, rework, and reduced ROI from ML initiatives.",
        },
    ],

    // HireExpertFacts Content
    expertFacts: {
        btnText: "book an appointment",
        heading: "Quick Facts About ",
        greenHeading: "Our Flutter Team",
        facts: [
            { text: "<strong>Experienced Flutter Developers:</strong> Our team includes highly skilled developers with expertise in Flutter app development." },
            { text: "<strong>Diverse Project Experience:</strong> We’ve successfully worked on a wide range of mobile app development projects, building cross-platform solutions with Flutter." },
            { text: "<strong>Fast & Efficient Development:</strong> Our developers use the Flutter framework to create apps quickly while ensuring they are high-quality & scalable." },
            { text: "<strong>Proven Record in Mobile App Development:</strong> Our team has a deep understanding of Dart programming & the Flutter framework to deliver top-notch mobile apps." },
            { text: "<strong>Cross-Platform Expertise:</strong> Whether it's iOS or android, we specialize in creating apps that perform well on both platforms." },
            { text: "<strong>Continuous Support:</strong> Our Flutter developers provide full support throughout the development process & beyond, helping with maintenance & updates." },
        ],
        backgroundImage: `url(/images/hire-page-images/hire-flutter.avif)`,
    },

    // HirePageAppIdea Content
    appIdeaSection: {
        heading: "Not sure about your app idea? Get your prototype up in 6-8 weeks!",
        content: "Have an idea but unsure how to proceed? Our Flutter experts can help you build a functional prototype in just 6-8 weeks! Validate your vision, test user engagement, & establish a strong foundation for success with our expert mobile app development services.",
    },

    // HirePageEngagementModels Component Props
    hirePageEngagementModels: {
        btnText: "Get Started Now",
        headingContent: [
            { text: "Our Flexible" },
            { text: "Engagement Models" },
        ],
        discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
        hiringDetails: [
            {
                text: "Hourly Hiring",
                hours: "48",
                timeUnit: "hours",
                icon: "time.svg",
                bgColor: "#FDFDFF",
                durationLabel: "Duration",
                duration: "8 Hrs/Day",
                minimumDaysLabel: "Minimum Days",
                minimumDays: "30 Days",
                billingLabel: "Billing",
                billing: "Monthly",
                startWorkPhrase: "Start work in "
            },
            {
                text: "Full Time Hiring",
                hours: "72",
                timeUnit: "hours",
                icon: "full-time.svg",
                bgColor: "#FFFEFA",
                durationLabel: "Duration",
                duration: "8 Hrs/Day",
                minimumDaysLabel: "Minimum Days",
                minimumDays: "30 Days",
                billingLabel: "Billing",
                billing: "Monthly",
                startWorkPhrase: "Get started within "
            },
            {
                text: "Part Time Hiring",
                hours: "48",
                timeUnit: "hours",
                icon: "part-time.svg",
                bgColor: "#FDFFFA",
                durationLabel: "Duration",
                duration: "8 Hrs/Day",
                minimumDaysLabel: "Minimum Days",
                minimumDays: "30 Days",
                billingLabel: "Billing",
                billing: "Monthly",
                startWorkPhrase: "Launch in "
            },
        ],
    },

    // SecondFaq Content
    faqSection: {
        mainHeading: "Frequently Asked Questions about Machine Learning",
        faqData: [
            {
                id: "collapseOne",
                question: "How do I engage Machine Learning engineers?",
                answer:
                    "To bring in the right Machine Learning expertise, assess candidates based on their proficiency with data modeling, algorithm design, and model deployment. Our vetting process ensures you connect with engineers who have hands-on experience in delivering scalable ML solutions tailored to your project’s needs.",
            },
            {
                id: "collapseTwo",
                question: "How long does it take to implement a Machine Learning model?",
                answer:
                    "The timeline depends on the complexity of your project. For basic models, prototype development can take 2–4 weeks, while enterprise-grade solutions involving big data and real-time analytics may require 6–12 weeks to ensure robust performance and accuracy.",
            },
            {
                id: "collapseThree",
                question: "How do you ensure security in Machine Learning projects?",
                answer:
                    "We incorporate security at every stage of the Machine Learning lifecycle by adhering to best practices for data privacy, encryption, and compliance (including GDPR, ISO, and SOC 2 standards). Our engineers implement DevSecOps principles to safeguard models and data.",
            },
            {
                id: "collapseFour",
                question: "What tools and technologies do your Machine Learning engineers use?",
                answer:
                    "Our engineers work with a wide array of ML frameworks and tools, including TensorFlow, PyTorch, Scikit-learn, Keras, and AWS SageMaker. We choose the right toolchain based on your project's goals, ensuring optimal performance and scalability.",
            },
            {
                id: "collapseFive",
                question: "Can Machine Learning solutions work for my industry?",
                answer:
                    "Yes, Machine Learning is transforming industries like finance, healthcare, e-commerce, and manufacturing. Our engineers build custom models to tackle industry-specific challenges, from predictive analytics and fraud detection to personalization and operational efficiency.",
            },
            {
                id: "collapseSix",
                question: "Can I engage Machine Learning engineers on an hourly or project basis?",
                answer:
                    "Yes. We offer flexible engagement models, allowing you to engage Machine Learning engineers on a project, part-time, or full-time basis. Whether you need short-term expertise for specific tasks or long-term support for continuous model improvement, we can tailor the engagement to your needs.",
            },
            {
                id: "collapseSeven",
                question: "How soon can I start working with a Machine Learning engineer?",
                answer:
                    "We can connect you with pre-vetted Machine Learning engineers within 2–3 business days. They are ready to integrate into your team immediately, ensuring that your project gets off the ground quickly and efficiently.",
            },
        ]
    },
    // You can remove other individual exports if they are now nested.
    // For example, if 'bannerList' is only used within 'mainBanner', it doesn't need to be a separate export.
    // I've kept them as separate for now, but you can clean them up.
};


export const comapnyCtaContent = {
    heading: "Frustrated with Generic Solutions?",
    subHeading: "We build custom Machine Learning solutions designed to meet your unique business needs.",
    buttonText: "Let’s Talk",
}